import endpoint from "../../config/endpoints";

export const EnquiryIntrestedProductJson = {
    showSaveNextBtn: true,
    formPath: "/enquiry-intrested-product-form",
    apiBaseURL: endpoint.enquiryIntrestedProduct,
    changeExcel: endpoint.exportData,
    screenTitle: "Enquiry Interested Product",
    showAddButton: true,
    showPdfDownload: false,
    pdfFileName: "Enquiry Interested Product",
    showExcelDownload: true,
    excelFileName: "Enquiry Interested Product",
    noteValue: 'Enquiry Interested Product',
    isActiveURL: endpoint.enquiryIntrestedProduct + "/update-is-active",
    tableColumnsToFilter: [
        {
            columnDisplayName: "Enquiry Interested Product Name",
            columnKeyName: "name",
            isChecked: true,
        },
        {
            columnDisplayName: "Status",
            columnKeyName: "isActive",
            isChecked: true,
        },
    ],
    fieldMeta: [
        {
            label: "Enquiry",
            controlType: "autocomplete",
            placeHolder: "Select Enquiry",
            md: 6,
            lg: 6,
            sm: 6,
            xs: 12,
            masterName: "EnquiryDetail",
            dataKey: "enquiryId",
            isRootLevelKey: true,
            isMandatory: true,
        },
        {
            label: "Product",
            controlType: "autocomplete",
            placeHolder: "Select Product",
            md: 6,
            lg: 6,
            sm: 6,
            xs: 12,
            masterName: "productDetail",
            dataKey: "productId",
            isRootLevelKey: true,
            isMandatory: true,
        },
    ],
};